import React, {Component} from "react"
import {connect} from "react-redux";
import withStyles from "@mui/styles/withStyles";
import {withRouter} from "react-router-dom";
import {Accordion, AccordionDetails, AccordionSummary, Box} from "@mui/material";
import Typography from "@mui/material/Typography";
import PrivacyPolicy from "./Dialogs/PrivacyPolicy";
import TermsOfService from "./Dialogs/TermsOfService";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const styles = {
    paper: {
        margin: 15
    },
    spanLink: {
        textDecoration: "underline",
        cursor: "pointer",
    },
    root: {
        minHeight: "calc(100vh - 86px)",
        position: "relative"
    }
};


class Faq extends Component {

    constructor(props) {
        super(props);
        let expanded = null;
        if (props.match.params.section === "shortcut") {
            expanded = 0;
        }

        this.state = {
            privacyPolicyOpened: false,
            termsOfServiceOpened: false,
            expanded: expanded
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.match.params.section !== this.props.match.params.section) {
            if (this.props.match.params.section === "shortcut") {
                this.setState({
                    ...this.state,
                    expanded: 0
                });
            } else {
                this.setState({
                    ...this.state,
                    expanded: null
                });
            }
        }
    }

    setOpened(index) {
        if (index === this.state.expanded) {
            this.setState({
                ...this.state,
                expanded: null
            });
        } else {
            this.setState({
                ...this.state,
                expanded: index
            });
        }
    }


    openPrivacyPolicy = () => {
        this.setState({
            ...this.state,
            privacyPolicyOpened: true
        });
    };

    closePrivacyPolicy = () => {
        this.setState({
            ...this.state,
            privacyPolicyOpened: false
        });
    };

    openTermsOfService = () => {
        this.setState({
            ...this.state,
            termsOfServiceOpened: true
        });
    };

    closeTermsOfService = () => {
        this.setState({
            ...this.state,
            termsOfServiceOpened: false
        });
    };


    render() {
        const {classes} = this.props;

        const questions = {
            "How can I create a shortcut to VOCA.CLICK on my desktop and/or display with VOCA.CLICK icon (favicon)?": <>
                You can create VOCA.CLICK shortcut with VOCA.CLICK icon (favicon) very easily by the following steps:
                <ol>
                    <li>Open the VOCA.CLICK in Chrome browser.</li>
                    <li>
                        Click the Chrome Menu button (3 dots). You&#39;ll find this in the upper-right corner of the Chrome
                        window.
                    </li>
                    <li>
                        Click “Create Shortcut” in tools or “Add to Home Screen” for mobile devices. A new window will
                        appear.
                    </li>
                    <li>
                        Enter a name for the shortcut. By default, the shortcut will have the VOCA.CLICK name.
                    </li>
                    <li>
                        Click “Create” for desktop or “Add” for mobile devices.
                    </li>
                </ol>
            </>,
            "How can I create a standard shortcut to VOCA.CLICK on my desktop?": <>
                <ol>
                    <li>
                        Make sure the browser isn&#39;t full screen. You&#39;ll need to be able to see your desktop in order for this to
                        work easily.
                    </li>
                    <li>
                        Click and drag the VOCA.CLICK line of letters in the address bar. You&#39;ll see an outline of the object
                        appear as you drag.
                    </li>
                    <li>
                        Release the icon on your desktop. A shortcut to the VOCA.CLICK will appear with the VOCA.CLICK
                        title as the name.
                    </li>
                </ol>
            </>,
            "Can I use VOCA.CLICK for free?": "Yes, you can use VOCA.CLICK for free with available functions, including the Starter Pack with words in the Clusters.",
            "How long can I use VOCA.CLICK for free?": "You can use VOCA.CLICK for free as long as you decide.",
            "How can I upgrade to Premium of VOCA.CLICK?": <>You can upgrade to Premium directly by the click <span
                className={classes.spanLink} onClick={() => {
                this.props.history.push("/premium")
            }}>HERE</span>.</>,
            "Does VOCA.CLICK work with Generative A. I.?": "Yes, the technology called Generative A. I. works on the background of A. I. Teacher text and voice, and of course, software engineers work on its improvement as well as accuracy.",
            "What does it mean Great Pack and Lite Pack?": "It is the total number of characters (in millions) available for Generative A. I. which works on the background of A. I. Teacher text and voice, and remaining number of input & output characters is always listed in your Premium tier of VOCA.CLICK based on your usage.",
            "What are Terms of Service of VOCA.CLICK?": <>
                We take care about the relationship with all users of
                VOCA.CLICK and Terms of Service represent the entire agreement between you and us. The Terms of Service
                are available <span className={classes.spanLink} onClick={this.openTermsOfService}>HERE</span>.
            </>,
            "What is Privacy Policy of VOCA.CLICK?": <>We take care about all users of VOCA.CLICK and your personal
                data, so we have prepared Privacy Policy to explain how we process it. The Privacy Policy is available
                <span> <span className={classes.spanLink} onClick={this.openPrivacyPolicy}>HERE</span></span>.</>,
            "How can I terminate my profile on VOCA.CLICK?": "You can terminate your profile directly in your profile interface of VOCA.CLICK. Note please, entire profile including the content of your profile will be permanently deleted.",
            "How can I contact VOCA.CLICK support?": <>You can contact VOCA.CLICK support <span
                className={classes.spanLink} onClick={() => {
                this.props.history.push("/contact")
            }}>via contact section</span>

            </>,
            "How can I turn off the predictive text during my writing?": "You can turn off the predictive text directly in keyboard setting of your computer and/or mobile devices. VOCA.CLICK accepts all keyboards of your computer and/or mobile devices with your setting preferences.",
            "Can I use various keyboards with special letters and symbols related to various languages?": "Yes, you can use various keyboards and VOCA.CLICK accepts all keyboards of your computer and/or mobile devices. Ensure please, the keyboard is appropriately installed on your computer and/or mobile devices.",
            "Can I use VOCA.CLICK globally?": "Yes, you can use VOCA.CLICK globally on all devices with internet connection directly via internet browser on all your devices – enjoy VOCA.CLICK with A. I. Teacher!"
        };
        return (
            <Box className={classes.root}>
                <PrivacyPolicy open={this.state.privacyPolicyOpened} closeHandle={this.closePrivacyPolicy}/>
                <TermsOfService open={this.state.termsOfServiceOpened} closeHandle={this.closeTermsOfService}/>
                <Box className={classes.paper}>
                    <Typography variant={"h5"} gutterBottom={true}>FAQs – Frequently Asked Questions</Typography>
                    {Object.entries(questions).map((current, index) => {
                        let question = current[0];
                        let answer = current[1];
                        return <Accordion key={"faq-" + index} expanded={this.state.expanded === index}
                                          onChange={() => this.setOpened(index)}
                                          style={{background: this.props.theming.darkMode ? "black" : "white"}}
                        >
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon/>}

                                id={"faq-" + index}
                            >
                                <Typography className={classes.heading}>
                                    {question}
                                </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Typography>
                                    {answer}
                                </Typography>
                            </AccordionDetails>
                        </Accordion>
                    })}

                </Box>
            </Box>)
    }
}

const mapStateToProps = state => ({
    theming: state.theming
});

export default withRouter(withStyles(styles)(connect(
    mapStateToProps,
    {}
)(Faq)));
